export const isPromotor = (codigo) => {
  switch (codigo) {
    case null:
      return false
    case undefined:
      return false
    case '':
      return false
    default:
      return true
  }
}
